import React from 'react';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage } from 'react-intl';
import { history } from '../../configuration/store';
import TenantManager from '../../components/tenantManager';
import tenants from './tenants';

import { VISITED_TIME } from './events';

import './timekeeping.css';

class TimeKeepingPage extends React.Component {
    componentDidMount() {
        mixpanel.track(VISITED_TIME);
    }
    render() {
        return (
            <div className="page timekeeping">
                <TenantManager {...tenants} {...this.props} />
            </div>
        );
    }
}

TimeKeepingPage.meta = {
    label: <FormattedMessage id={'time'} defaultMessage={'Timekeeping'} />,
    icon: 'access_time',
    action: () => history.push('/time'),
    locations: ['/time']
};

export default TimeKeepingPage;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/index.jsx